export const isLoggedOut = (state) => state.isLoggedOut
